const RECAPTCHA_SITE_KEY = '6Ld5LlEsAAAAAH5xnbgLhvCfm0gwfe6jaWiVWAyF';

if (!customElements.get('esim-form')) {
  customElements.define(
    'esim-form',
    class EsimForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('#free-esim-form');
        this.submitBtn = this.querySelector('#submit-btn');
        this.messageDiv = this.querySelector('#form-message');
      }

      connectedCallback() {
        const init = () => {
          this.form.addEventListener('submit', this.formSubmitHandler.bind(this));
        };
        document.readyState === 'loading'
          ? document.addEventListener('DOMContentLoaded', init, { once: true })
          : init();
      }
      disconnnectedCallback() {
        this.form.removeEventListener('submit', this.formSubmitHandler.bind(this));
      }

      async getCountryCode() {
        const loadFeatures = new Promise((resolve) => {
          window.Shopify.loadFeatures(
            [{ name: 'consent-tracking-api', version: '0.1' }],
            (error) => {
              if (error) {
                console.error(error);
                resolve(null);
                return;
              }
              resolve(window.Shopify.customerPrivacy);
            },
          );
        });

        const privacy = await loadFeatures;
        return (
          (privacy?.getRegion && privacy.getRegion()).slice(0, 2) || window.Shopify.country || ''
        );
      }

      async formSubmitHandler(e) {
        e.preventDefault();

        // Disable submit button and show loading state
        this.submitBtn.disabled = true;
        this.submitBtn.textContent = 'Processing...';
        this.hideMessage();

        try {
          // Get form data
          const firstName = this.querySelector('#firstName').value.trim();
          const email = this.querySelector('#email').value.trim();
          const countryCode = await this.getCountryCode();

          //   Validate form
          if (!firstName || !email || !countryCode) {
            this.showMessage('Please fill in all required fields.', 'error');
            this.submitBtn.disabled = false;
            this.submitBtn.textContent = 'Get Free eSIM';
            return;
          }

          //   Execute reCAPTCHA
          this.submitBtn.textContent = 'Verifying...';
          const token = await new Promise((resolve, reject) => {
            grecaptcha.enterprise.ready(() => {
              grecaptcha.enterprise
                .execute(RECAPTCHA_SITE_KEY, { action: 'submit_free_esim' })
                .then(resolve)
                .catch(reject);
            });
          });

          //   Submit to backend
          this.submitBtn.textContent = 'Submitting...';
          const response = await fetch('/apps/simify-proxy/promotionalEsim', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              firstName: firstName,
              email: email,
              countryCode: countryCode,
              captchaToken: token,
              affiliate: window.affiliate_partner,
            }),
          });

          // Handle response
          if (response.ok) {
            this.showMessage(
              'Success! Your free eSIM order has been created. Check your email for details.',
              'success',
            );
            this.form.reset();
          } else if (response.status === 429) {
            const retryAfter = response.headers.get('Retry-After');
            this.showMessage(
              `Too many requests. Please wait ${retryAfter || '5'} seconds before trying again.`,
              'error',
            );
          } else if (response.status === 422) {
            this.showMessage(
              'You already have existing orders with us. This promotion is for new customers only.',
              'error',
            );
          } else if (response.status === 403) {
            this.showMessage('Verification failed. Please try again.', 'error');
          } else {
            const errorText = await response.text();
            this.showMessage(errorText || 'Something went wrong. Please try again.', 'error');
          }
        } catch (error) {
          console.error('Form submission error:', error);
          this.showMessage(
            'An error occurred. Please check your connection and try again.',
            'error',
          );
        } finally {
          // Re-enable submit button
          this.submitBtn.disabled = false;
          this.submitBtn.textContent = 'Get Free eSIM';
        }
      }

      hideMessage() {
        this.messageDiv.style.display = 'none';
      }

      showMessage(message, type) {
        this.messageDiv.textContent = message;
        this.messageDiv.className = 'free-esim-message free-esim-message--' + type;
        this.messageDiv.style.display = 'block';
      }
    },
  );
}
